import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-loading',
  templateUrl: './loading.component.html',
  styleUrls: ['./loading.component.css']
})
export class LoadingComponent {

  @Input()
  public loading: boolean;
}



// WEBPACK FOOTER //
// ./src/app/loading/loading.component.ts